import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenTitle'
})
export class ShortenTitlePipe implements PipeTransform {
  transform(value: string, charLimit: number = 10, trail: string = '...'): string {
    if (!value) {
      return '';
    }

    // Remove spaces to count only actual characters
    const titleWithoutSpaces = value.replace(/\s+/g, '');

    if (titleWithoutSpaces.length <= charLimit) {
      return value;  // Return original if it's within limit
    }

    let result = '';
    let charCount = 0;

    // Go through original string and build result until we hit the char limit
    for (let i = 0; i < value.length; i++) {
      if (value[i] !== ' ') {
        charCount++;
      }
      if (charCount > charLimit) {
        break;
      }
      result += value[i];
    }

    return result.trim() + trail;
  }
}